import { DumQueryApi } from '@src/Api/generated-global-event';
import { useStores } from '@src/Common/Hooks/useStores';
import AxiosInstanceGlobalEvent from '@src/Common/Services/Api/AxiosInstanceGlobalEvent';
import { AxiosInstance } from 'axios';
import { useEffect } from 'react';
const lDEQa = (AI: AxiosInstance) => new DumQueryApi(undefined, '', AI);
const useAllEventsDialog = () => {
  const { AllEventStore } = useStores();
  const fetchDUMEvent = lDEQa(AxiosInstanceGlobalEvent(''));
  useEffect(() => {
    AllEventStore.loadEvent(fetchDUMEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {};
};

export default useAllEventsDialog;
